import React from "react";
import { Text, Stack, PrimaryButton } from "office-ui-fabric-react/lib";
import { mdiDiameterVariant } from "@mdi/js";
import Icon from "@mdi/react";
import { Card } from "@uifabric/react-cards";
import { GS } from "../../utils/Styles";

export interface NotAuthorizedPageProps { }

export interface NotAuthorizedPageState { }

class NotAuthorizedPage extends React.Component<NotAuthorizedPageProps, NotAuthorizedPageState> {
    constructor(props: NotAuthorizedPageProps) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <>
                <Stack horizontal horizontalAlign="center" verticalAlign="center" verticalFill={true}>
                    <Stack.Item align="center">
                        <Card className="padding-16" horizontal styles={{ root: { width: 415, ...GS.bgWhite, display: "flex", flexDirection: "column", justifyContent: "center" } }}>
                            <Card.Item styles={{ root: { alignSelf: "center" } }}>
                                <Icon path={mdiDiameterVariant} size="98px" color="#b92b32" />
                            </Card.Item>
                            <Card.Item>
                                <Text variant="xLarge">Account is not authorized for this page.</Text>
                            </Card.Item>
                            <br/>
                            <Card.Item styles={{ root: { alignSelf: "center" } }}>
                                <PrimaryButton label="home" href="/" color="primary" aria-label="home">
                                    Home
                                </PrimaryButton>
                            </Card.Item>
                        </Card>
                    </Stack.Item>
                </Stack>
            </>
        );
    }
}

export default NotAuthorizedPage;
